<app-text-area-input
    [form]="form"
    id="message"
    label="folder.restore.fields.message"
></app-text-area-input>
